<template>
  <div>
    <vx-card id="groupDataContainer" :title="$t('caller_id')" class="mb-8 vs-con-loading__container">
      <shared-caller-id-list
        :callerIds="callerIds"
        @editCallerId="editCallerIdPopup"
      ></shared-caller-id-list>
      <template slot="footer">
        <paginate
          :total="callerIdPages"
          :itemPerPage="itemPerPage"
          :click-handler="loadCallerIdData"
          v-model="initialPage"
          goto
        >
        </paginate>
      </template>

    </vx-card>
  </div>
</template>

<script>
import CallerId from '@/models/CallerId'
import Paginate from '@/mixins/paginate'
import SharedCallerIdList from '@/views/Shared/Configuration/CallerId/List'
import Utils from '@/helpers/utils'

export default {
  name: 'User.Configuration.CallerId',
  mixins: [Paginate],
  components: {
    SharedCallerIdList
  },
  data () {
    return {
      callerIds: {},
      itemPerPage: null,
      callerIdPages: 1
    }
  },
  mounted () {
    this.loadCallerIdData(this.initialPage, null, true)
    this.$windowOpenerHelper.listenToPopUpMessage('reload_configuration_caller_id_table', this.reloadCallerIdData)
  },
  methods: {
    reloadCallerIdData () {
      this.loadCallerIdData(this.initialPage, this.itemPerPage)
    },
    async loadCallerIdData (page = 1, itemPerPage = null, isOnLoad = false) {
      this.$vs.loading({container: '#groupDataContainer'})
      if (itemPerPage !== null) {
        this.itemPerPage = itemPerPage
      } else if (this.itemPerPage !== null) {
        itemPerPage = this.itemPerPage
      }
      if (!isOnLoad) {
        this.$router.replace({ query: { page, itemPerPage } })
      }
      const response = await CallerId.all({ page, itemPerPage })
      this.callerIds = response.data.data.callerIds
      this.callerIdPages = response.data.meta.pagination.last_page
      this.itemPerPage = response.data.meta.pagination.per_page
      this.initialPage = page

      this.$vs.loading.close('#groupDataContainer > .con-vs-loading')
    },
    editCallerIdModal () {
      this.modals.add = true
    },
    editCallerIdPopup (callerId) {
      Utils.openPopUp(this.$store.getters.ctiPopUp, 'edit-caller-id', { caller_id: callerId}, this.editCallerIdModal)
    }
  }
}
</script>

<style lang="scss">

</style>
